import React, { useState, useEffect } from 'react';
import './ThreadView.css';

const ThreadView = ({ thread, onClose, onSendReply, user }) => {
  const [replies, setReplies] = useState([]);
  const [replyContent, setReplyContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (thread) {
      fetchThreadReplies();
    }
  }, [thread]);

  const fetchThreadReplies = async () => {
    try {
      setLoading(true);
      const response = await fetch(`/api/chat/rooms/threads/${thread._id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const data = await response.json();
      if (data.success) {
        setReplies(data.data.replies);
      }
    } catch (error) {
      console.error('Failed to fetch thread:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSendReply = async (e) => {
    e.preventDefault();
    if (!replyContent.trim()) return;

    await onSendReply(replyContent, thread._id);
    setReplyContent('');
    fetchThreadReplies();
  };

  if (!thread) return null;

  return (
    <div className="thread-view-overlay" onClick={onClose}>
      <div className="thread-view-panel" onClick={(e) => e.stopPropagation()}>
        <div className="thread-header">
          <h3>Thread</h3>
          <button className="close-thread" onClick={onClose}>×</button>
        </div>

        <div className="thread-parent-message">
          <div className="message-header">
            <img src={thread.senderId.profile?.avatar?.url || '/default-avatar.png'} alt="" className="avatar-sm" />
            <span className="username">{thread.senderId.username}</span>
            <span className="timestamp">{new Date(thread.createdAt).toLocaleString()}</span>
          </div>
          <div className="message-content">{thread.content}</div>
        </div>

        <div className="thread-replies">
          {loading ? (
            <div className="loading">Loading replies...</div>
          ) : replies.length === 0 ? (
            <div className="no-replies">No replies yet. Be the first to reply!</div>
          ) : (
            replies.map(reply => (
              <div key={reply._id} className="thread-reply">
                <img src={reply.senderId.profile?.avatar?.url || '/default-avatar.png'} alt="" className="avatar-sm" />
                <div className="reply-content">
                  <div className="reply-header">
                    <span className="username">{reply.senderId.username}</span>
                    <span className="timestamp">{new Date(reply.createdAt).toLocaleString()}</span>
                  </div>
                  <div className="reply-text">{reply.content}</div>
                </div>
              </div>
            ))
          )}
        </div>

        <form className="thread-reply-form" onSubmit={handleSendReply}>
          <input
            type="text"
            placeholder="Reply to thread..."
            value={replyContent}
            onChange={(e) => setReplyContent(e.target.value)}
            className="reply-input"
          />
          <button type="submit" className="send-reply-btn" disabled={!replyContent.trim()}>
            Send
          </button>
        </form>
      </div>
    </div>
  );
};

export default ThreadView;
